import { Container, FormControl, NativeSelect } from "@material-ui/core";
import React from "react";
import styles from "./Picker.module.css";
import { connect } from "react-redux";
import { makeStyles, Paper, Divider, IconButton } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";
import LockIcon from "@material-ui/icons/Lock";
import MenuOpenIcon from "@material-ui/icons/MenuOpen";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";
// store & actions
import * as actionTypes from "../store/actionTypes";
import { useDispatch } from "react-redux";
import { authActions } from "../store/actions/auth.action";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    // background: "rgba(255, 255, 255, 0.5)",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },

  searchLayout: {
    [theme.breakpoints.down("md")]: {
      position: "absolute",
      top: 20,
      left: 0,
      right: 0,
    },
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      top: 20,
      left: 0,
      right: 0,
    },
    position: "absolute",
    top: 20,
  },
}));

const Picker = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { isAuth, open } = props;

  const getStateLocation = (state) => {
    let selectedState = props.states.filter((item) => item.value === state);
    props.onStateAdd(selectedState[0]);
  };

  const tellUsYouAreGenZ = (e) => {
    e.preventDefault();
    const getMasterCode = prompt("Enter Master Code");
    if (getMasterCode === "ResistanceMapDev2021_GenZ") {
      const payload = {
        fullname: "R4Y",
        token: "token ma shi wo :3",
      };
      dispatch(authActions.openMasterCode(payload));
    }
  };

  const onLogout = () => {
    dispatch(authActions.logout());
  };
  return (
    <div className={classes.searchLayout}>
      <Container>
        <Paper component="form" className={classes.root}>
          {isAuth ? (
            <IconButton
              className={classes.iconButton}
              aria-label="menu"
              onClick={props.toggleDrawer("right", !open)}
            >
              <MenuOpenIcon />
            </IconButton>
          ) : (
            <IconButton className={classes.iconButton} aria-label="menu">
              <MenuIcon />
            </IconButton>
          )}

          <FormControl variant="standard" className={styles.formControl}>
            <NativeSelect
              default="Yangon"
              onChange={(e) => {
                getStateLocation(e.target.value);
              }}
              disableUnderline
              className={classes.input}
            >
              {props.states.map((state, i) => (
                <option key={i} value={state.value}>
                  {state.name}
                </option>
              ))}
            </NativeSelect>
          </FormControl>
          <IconButton className={classes.iconButton} aria-label="search">
            <SearchIcon />
          </IconButton>
          <Divider className={classes.divider} orientation="vertical" />
          {isAuth ? (
            <IconButton
              color="primary"
              className={classes.iconButton}
              aria-label="directions"
              onClick={onLogout}
            >
              <MeetingRoomIcon />
            </IconButton>
          ) : (
            <IconButton
              color="primary"
              className={classes.iconButton}
              aria-label="directions"
              onClick={tellUsYouAreGenZ}
            >
              <LockIcon />
            </IconButton>
          )}
        </Paper>
      </Container>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    onStateAdd: (selectedState) =>
      dispatch({ type: actionTypes.ADD_SELECTED_STATE, state: selectedState }),
  };
};
export default connect(null, mapDispatchToProps)(Picker);
